export default {
  searchResultLabel: 'LabelShowingResultsFor',
  searchInsteadForLabel: 'LabelSearchInsteadFor',
  emptyResultLabel: 'LabelNoSearchResults',
  searchSuggestedKeyworkLabel: 'LabelSearchYouMightMean',
  keywordPickUpSelector: 'games-search-page',
  keywordDataAttribute: 'data-keyword',
  searchQueryParamName: 'keyword'
};
